import { useState, useCallback, useEffect } from 'react';

import { storeItemsListener } from '~/firebase/listeners/store';

import { CollectionSnapShotFn } from '~/firebase/listeners/type';
import { Item, ItemWithId } from '~/types/store/item';

export default function useStoreItems(storeId: string) {
  const [itemsMap, setItemsMap] = useState<Map<string, ItemWithId>>(new Map());

  const handleItemsSnapshot = useCallback<CollectionSnapShotFn>(
    (snap) => {
      setItemsMap(
        snap.docs.reduce<Map<string, ItemWithId>>((acc, doc) => {
          const item = doc.data() as Item;

          acc.set(doc.id, { id: doc.id, ...item });
          return acc;
        }, new Map()),
      );
    },
    [setItemsMap],
  );

  useEffect(() => {
    if (storeId) {
      const unlisten = storeItemsListener(storeId, handleItemsSnapshot);
      return () => {
        unlisten();
      };
    }
  }, [storeId]);

  return itemsMap;
}
